
import { defineComponent } from "vue";
import { createGhlSite, listGhlSites } from "@/api/ghlSites.api.js";

export default defineComponent({
  name: "SitesList",
  data() {
    return {
      loading: true,
      creating: false,
      showCreate: false,
      error: "",
      sites: [] as any[],
      form: {
        name: "",
        slug: ""
      }
    };
  },
  async mounted() {
    await this.loadSites();
  },
  methods: {
    formatError(err: unknown, fallback: string) {
      const e = err as { response?: { data?: { message?: string } }; message?: string };
      return e?.response?.data?.message || e?.message || fallback;
    },
    async loadSites() {
      this.loading = true;
      this.error = "";
      try {
        const response = await listGhlSites();
        this.sites = response.data?.sites || [];
      } catch (err) {
        this.error = this.formatError(err, "Failed to load sites");
      } finally {
        this.loading = false;
      }
    },
    async createSite() {
      this.creating = true;
      this.error = "";
      try {
        const payload = {
          name: this.form.name.trim(),
          slug: this.form.slug.trim() || undefined
        };
        const response = await createGhlSite(payload);
        const site = response.data?.site;
        if (site?.id) {
          this.$router.push({ path: `/sites/${site.id}/edit` });
          return;
        }
        await this.loadSites();
        this.showCreate = false;
        this.form = { name: "", slug: "" };
      } catch (err) {
        this.error = this.formatError(err, "Failed to create site");
      } finally {
        this.creating = false;
      }
    }
  }
});
